// Canonical vocabulary for a product's `pricingType` column (products.product
// .pricing_type, plain text). Title Case is load-bearing, not cosmetic: the
// product edit tab matches the stored value against this list and silently
// falls back to 'Unit' on a miss, so a product written as 'NIGHT' renders — and
// on the next Save persists — as a per-unit price.
//
// Distinct from the itinerary ITEM pricing vocabulary (SINGLE/UNIT/…/GROUP,
// upper case) in the itinerary pricing table; that is a different column on a
// different entity.
export const PRODUCT_PRICING_OPTIONS = [
  'Unit',
  'Piece',
  'Hour',
  'Night',
  'Day',
  'Pax',
  'Vehicle',
  'Group',
] as const;

export type ProductPricingOption = (typeof PRODUCT_PRICING_OPTIONS)[number];

const BY_UPPER = new Map<string, ProductPricingOption>(
  PRODUCT_PRICING_OPTIONS.map((o) => [o.toUpperCase(), o])
);

// Resolve free-text (a spreadsheet cell, a legacy upper-case row) to the
// canonical member. Case- and whitespace-insensitive; null when unknown.
export const toProductPricingOption = (
  raw: string | null | undefined
): ProductPricingOption | null => {
  if (!raw) return null;
  return BY_UPPER.get(raw.trim().toUpperCase()) ?? null;
};
